import ChartSquareSvg from "../../../../assets/icon/svgJsx/ChartSquareSvg";
import CoinSvg from "../../../../assets/icon/svgJsx/CoinSvg";
import MapSvg from "../../../../assets/icon/svgJsx/MapSvg";
import NotificationSvg from "../../../../assets/icon/svgJsx/NotificationSvg";
import MessageTextSvg from "../../../../assets/icon/svgJsx/MessageTextSvg";
import ProfileSvg from "../../../../assets/icon/svgJsx/ProfileSvg";
import SettingSvg from "../../../../assets/icon/svgJsx/SettingSvg";
import RowVerticalSvg from "../../../../assets/icon/svgJsx/RowVerticalSvg";
import StrongBoxSvg from "../../../../assets/icon/svgJsx/StrongBoxSvg";
import SetupSvg from "../../../../assets/icon/svgJsx/SetupSvg";


export const getNavSVGIcon = (iconName) => {
    const iconMap = {
        CHARTSQUARE: <ChartSquareSvg/>,
        COIN: <CoinSvg/>,
        MAP: <MapSvg/>,
        NOTIFICATION: <NotificationSvg/>,
        MESSAGETEXT: <MessageTextSvg/>,
        PROFILE: <ProfileSvg/>,
        SETTING: <SettingSvg/>,
        ROWVERTICAL: <RowVerticalSvg/>,
        STRONGBOX: <StrongBoxSvg/>,
        SETUPSVG: <SetupSvg/>
    };

    if (iconMap[iconName.toUpperCase()]) {
        return iconMap[iconName.toUpperCase()];
    } else {
        console.error(`Invalid iconName => "${iconName}". Supported iconName are: [${Object.keys(iconMap).join("], [")}]`);
        return null;
    }
};


export default getNavSVGIcon;